"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _selectors = require("settings-ui-sdk/Blogs/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _reactRouterRedux = require("react-router-redux");

var _Blog = _interopRequireDefault(require("settings-ui-sdk/Blogs/Blog"));

var _selectors3 = require("settings-ui-sdk/Auth/selectors");

var _BlogSettingsHeader = _interopRequireDefault(require("../components/BlogSettingsHeader"));

var _modalActions = require("../actions/interactions/modalActions");

var _AsyncCreateNewBlogModalContainer = _interopRequireDefault(require("./modals/AsyncCreateNewBlogModalContainer"));

var _AsyncDeleteBlogModalContainer = _interopRequireDefault(require("./modals/AsyncDeleteBlogModalContainer"));

var BlogSettingsHeaderContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BlogSettingsHeaderContainer, _Component);

  function BlogSettingsHeaderContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, BlogSettingsHeaderContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BlogSettingsHeaderContainer).call(this, props));
    _this.handleSelectedTabChange = _this.handleSelectedTabChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelectedBlogChange = _this.handleSelectedBlogChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BlogSettingsHeaderContainer, [{
    key: "handleSelectedTabChange",
    value: function handleSelectedTabChange(evt) {
      var blogFromRoute = this.props.blogFromRoute;
      var tabId = evt.target.value;
      this.props.push("website/blogs/" + blogFromRoute.get('id') + "/" + tabId);
    }
  }, {
    key: "handleSelectedBlogChange",
    value: function handleSelectedBlogChange(evt) {
      var activeTab = this.props.activeTab;
      var blogId = evt.target.value;
      this.props.push("website/blogs/" + blogId + "/" + activeTab);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          blogOptions = _this$props.blogOptions,
          blogFromRoute = _this$props.blogFromRoute,
          activeTab = _this$props.activeTab,
          moreThanOneBlog = _this$props.moreThanOneBlog,
          blogImporterRoute = _this$props.blogImporterRoute,
          isReadOnly = _this$props.isReadOnly;
      return _react.default.createElement("div", null, _react.default.createElement(_BlogSettingsHeader.default, {
        moreThanOneBlog: moreThanOneBlog,
        blogOptions: blogOptions,
        selectedBlog: blogFromRoute,
        onCreateBlog: this.props.openNewBlogModal,
        onDeleteBlog: this.props.openDeleteBlogModal,
        activeTab: activeTab,
        onSelectedTabChange: this.handleSelectedTabChange,
        onSelectedBlogChange: this.handleSelectedBlogChange,
        blogImporterRoute: blogImporterRoute,
        readOnly: isReadOnly
      }), _react.default.createElement(_AsyncCreateNewBlogModalContainer.default, null), _react.default.createElement(_AsyncDeleteBlogModalContainer.default, null));
    }
  }]);
  return BlogSettingsHeaderContainer;
}(_react.Component);

BlogSettingsHeaderContainer.propTypes = {
  blogOptions: _react.PropTypes.array.isRequired,
  moreThanOneBlog: _react.PropTypes.bool.isRequired,
  blogFromRoute: _react.PropTypes.instanceOf(_Blog.default).isRequired,
  activeTab: _react.PropTypes.string.isRequired,
  push: _react.PropTypes.func.isRequired,
  openNewBlogModal: _react.PropTypes.func.isRequired,
  openDeleteBlogModal: _react.PropTypes.func.isRequired,
  blogImporterRoute: _react.PropTypes.string.isRequired,
  isReadOnly: _react.PropTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  var blogOptions = (0, _selectors.getBlogsAsSelectInputOptions)(state);
  var moreThanOneBlog = blogOptions.length > 1;

  _Routes.default.init((0, _selectors3.getUserGates)(state));

  return {
    moreThanOneBlog: moreThanOneBlog,
    blogOptions: blogOptions,
    blogFromRoute: (0, _selectors.getBlogFromRoute)(state),
    activeTab: (0, _selectors2.getActiveTabIdFromRoute)(state),
    blogImporterRoute: _Routes.default.blogImporter(),
    isReadOnly: !(0, _selectors3.getCanEditBlogSettings)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  push: _reactRouterRedux.push,
  openNewBlogModal: _modalActions.openNewBlogModal,
  openDeleteBlogModal: _modalActions.openDeleteBlogModal
})(BlogSettingsHeaderContainer);

exports.default = _default;
module.exports = exports.default;